
const mimeMap = {
  // text file
  'text/plain':               '.txt',
  // json
  'text/json':                '.json',
  'application/json':         '.json',
  // code files
  'text/html':                '.html',
  'text/css':                 '.css',
  'text/xml':                 '.xml',
  'application/x-javascript': '.js',
  'application/rss+xml':      '.rss',
  'text/x-component':         '.htc',
  
  // office documents
  'application/pdf':               '.pdf',
  'application/msword':            '.doc',
  'application/vnd.ms-excel':      '.xls',
  'application/vnd.ms-powerpoint': '.ppt',
  'application/vnd.ms-access':     '.mdb',

  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template': '.dotx',
  'application/vnd.ms-word.document.macroEnabled.12': '.docm',
  'application/vnd.ms-word.template.macroEnabled.12': '.dotm',

  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template': '.xltx',
  'application/vnd.ms-excel.sheet.macroEnabled.12': '.xlsm',
  'application/vnd.ms-excel.template.macroEnabled.12': '.xltm',
  'application/vnd.ms-excel.addin.macroEnabled.12': '.xlam',
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12': '.xlsb',

  'application/vnd.openxmlformats-officedocument.presentationml.presentation': '.pptx',
  'application/vnd.openxmlformats-officedocument.presentationml.template': '.potx',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow': '.ppsx',
  'application/vnd.ms-powerpoint.addin.macroEnabled.12': '.ppam',
  'application/vnd.ms-powerpoint.presentation.macroEnabled.12': '.pptm',
  'application/vnd.ms-powerpoint.template.macroEnabled.12': '.potm',
  'application/vnd.ms-powerpoint.slideshow.macroEnabled.12': '.ppsm',

  // zip/rar/7z
  'application/zip':              '.zip',
  'application/x-rar-compressed': '.rar',
  'application/x-7z-compressed':  '.7z',

  // images
  'image/jpeg':         '.jpg',
  'image/png':          '.png',
  'image/svg+xml':      '.svg',
  'image/gif':          '.gif',
  'image/x-ms-bmp':     '.bmp',
  'image/webp':         '.webp',
  'image/tiff':         '.tiff',
  'image/vnd.wap.wbmp': '.wbmp',
  'image/x-icon':       '.ico',
  'image/x-jng':        '.jng',

  // audio
  'audio/mpeg':      '.mp3',
  'audio/x-mepg':    '.mp3',
  'audio/wav':       '.wav',
  'audio/x-wav':     '.wav',
  'audio/ogg':       '.ogg',
  'audio/oggm':      '.ogg',
  'audio/webm':      '.webm',
  'audio/acc':       '.acc',
  'audio/3gpp':      '.3gpp',
  'audio/3gpp2':     '.3gpp2',
  'audio/midi':      '.mid',

  // video
  'video/mpeg':      '.mp4',
  'video/mp4':       '.mp4',
  'video/webm':      '.webm',
  'video/ogg':       '.ogg',
  'video/x-msvideo': '.avi',
  'video/3gpp':      '.3gpp',
  'video/3gpp2':     '.3gpp2',
}

export const getFileExtensionFromMime = (mime) =>
{
  return mimeMap[mime] || ''
}